import client from './client';

// User : 계정 내 user 반환
export const getUsers = () => client.get('/my/account/users');

// User : 삭제
export const deleteUser = (userId) =>
  client.delete(`/my/account/user/${userId}`);

// User : 정보 얻어오기
export const getUser = (user_id) => client.get('/my/account/user/' + user_id);

// User : 정보 수정하기
export const modifyUser = ({ user_id, form }) =>
  client.put('/my/account/user/' + user_id, form);

// (2021/03) version Flow ==========
// User : 폰번호 중복 확인
export const checkPhone = (phone) =>
  client.get(`/account/duplicates?phone_number=${encodeURIComponent(phone)}`);

// User : 휴대폰 인증번호 전송
export const verifyPhone = ({ temporary_id, phone_number }) =>
  client.post(`/account/join/b2c/${temporary_id}/phone`, { phone_number });

// User : 휴대폰 인증번호 재전송
export const verifyPhoneResend = ({ temporary_id, phone_number }) =>
  client.post(`/account/join/b2c/${temporary_id}/resend-verification`, {
    phone_number,
  });

// User : 인증번호 확인
export const verifyCode = ({ temporary_id, verification_code }) =>
  client.post(`/account/join/b2c/${temporary_id}/verify-phone`, {
    verification_code,
  });

// User : 닉네임 중복 확인
export const checkNickname = (nickname) =>
  client.get(`/account/duplicates?nickname=${encodeURIComponent(nickname)}`);

// User : 기본 정보 등록 (nickname, gender, birthyear)
// 닉네임 중복체크 자동으로 해줌
export const addUserBasicInfo = ({ temporary_id, basic_info }) =>
  client.post('/account/join/b2c/' + temporary_id + '/user-basic', basic_info);

// User : 문진 등록
export const addUserProfile = ({ temporary_id, profile_info }) =>
  client.post(
    '/account/join/b2c/' + temporary_id + '/user-profile',
    profile_info,
  );

// User : 등록 완료
export const addUserFinalize = ({ temporary_id }) =>
  client.post('/account/join/b2c/' + temporary_id + '/finalize');

// 제품쿠폰 다운로드 받기
export const downloadCoupon = ({ coupon_id, user_id, category }) =>
  client.post('/mall/coupon/download', {
    coupon_id,
    user_id,
    ...(category && { category }),
  });

// 보유한 쿠폰 리스트 불러오기
export const getValidCouponList = ({ user_id }) =>
  client.get(`/mall/coupon/valid/${user_id}`);
